import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import './scss/login.scss';
import '../Home/Error/errors.scss';
import huggies from './images/Texto.png';

import { API_BASE } from "../config/api";

const ResetPassword = () => {
  const _url = API_BASE;
  const [token, setToken] = useState('');
  const [pwd, setPwd] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [ok, setOk] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setToken(params.get('token') || '');
  }, []);

  // ÚNICA validación: mínimo 8 caracteres
  const validity = useMemo(() => {
    const hasMin = pwd.length >= 8;
    return { hasMin };
  }, [pwd]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg('');
    if (!token) { setMsg('Enlace inválido o incompleto.'); return; }
    if (!validity.hasMin) { setMsg('La contraseña debe tener al menos 8 caracteres.'); return; }

    setIsLoading(true);
    try {
      const res = await fetch(`${_url}/assistant/password/reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: pwd })
      });
      if (res.ok) {
        setOk(true);
        setMsg('Tu contraseña fue actualizada. Ya puedes iniciar sesión.');
      } else {
        const { detail } = await res.json().catch(()=>({detail:'No fue posible actualizar la contraseña.'}));
        const errMsg = (typeof detail === "object" && detail?.message) ? detail.message : (detail || "");
        setMsg(errMsg || 'No fue posible actualizar la contraseña.');
      }
    } catch {
      setMsg('No hay conexión con el servidor. Verifica tu conexión e intenta de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const bullet = (ok) => (
    <span className={`pw-dot ${ok ? 'ok' : ''}`} aria-hidden>•</span>
  );

  return (
    <div className="login-container">
      {/* Panel izquierdo: igual que Login */}
      <div className="image-container">
        <img src={huggies} alt="Huggies Product" />
      </div>

      {/* Panel derecho */}
      <div className="login-form">
        <img src="/logoF.png" alt="Logo" className="logo" />
        <h2 className="form-title">Cambio de contraseña</h2>

        {ok ? (
          <>
            <p className="hint">{msg}</p>
            <Link className="btn-ghost" to="/">Ir a iniciar sesión</Link>
          </>
        ) : (
          // PINTA TODO EL TEXTO ROJO/VERDE SEGÚN LA ÚNICA REGLA
          <form
            onSubmit={handleSubmit}
            style={{
              color: pwd ? (validity.hasMin ? '#16a34a' : '#dc2626') : undefined
            }}
          >
            <label className="input-label">Nueva contraseña</label>
            <input
              type="password"
              placeholder="Ingresa tu nueva contraseña"
              value={pwd}
              onChange={(e)=>setPwd(e.target.value)}
              className={!pwd ? '' : (validity.hasMin ? 'is-valid' : 'is-invalid')}
            />

            <ul
              className="pw-hints"
              style={{ color: validity.hasMin ? '#16a34a' : '#dc2626' }}
            >
              <li>{bullet(validity.hasMin)} Mínimo 8 caracteres</li>
            </ul>

            {msg && (
              <div className="form-inline-alert form-inline-alert--error">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
                  <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
                  <path d="M15 9L9 15M9 9l6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
                <span>{msg}</span>
              </div>
            )}

            <button type="submit" disabled={isLoading}>
              {isLoading ? <div className="loader"></div> : 'Actualizar contraseña'}
            </button>

            <div className="form-footer">
              <Link to="/">Volver al inicio de sesión</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
